import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SquadsGridRoutingComponent } from "./squads-grid-routing.component";

const routes: Routes = [
    {
        path: "",
        component: SquadsGridRoutingComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SquadRoutingModule {}
